import React from 'react';
import {
  ActionList,
  ActionListItem,
  Dropdown,
  DropdownButton,
  DropdownOverlay,
  MoreHorizontalIcon,
} from '@razorpay/blade/components';
import { routePaths } from 'components/Routes/data';
import { BulkUploadTypes } from 'constants/bulkUpload';
import { useHistory } from 'react-router-dom';
import useFeature from 'hooks/useFeature';
import useIsFeatureDisabledForRearch from 'access/useIsFeatureDisabledForRearch';

export const BulkActions = () => {
  const history = useHistory();
  const { isBulkOnboardingFlagEnabled: shouldShowUpdateEmployeeAction } =
    useFeature('bulkOnboardingFlag');
  const isBulkFnfEnabled = useFeature('bulk-fnf')['isBulk-fnfEnabled'];

  const { isBulkFnFDisabled } = useIsFeatureDisabledForRearch();

  const shouldShowBulkFnfActions = isBulkFnFDisabled ? false : isBulkFnfEnabled;

  if (!shouldShowBulkFnfActions && !shouldShowUpdateEmployeeAction) {
    return null;
  }

  return (
    <Dropdown>
      <DropdownButton
        variant="tertiary"
        icon={MoreHorizontalIcon}
        iconPosition="right"
        accessibilityLabel="more options"
      />

      <DropdownOverlay>
        <ActionList>
          {shouldShowUpdateEmployeeAction && (
            <ActionListItem
              title="Bulk Update Employee Details"
              value="bulk-update-employees"
              onClick={() => {
                history.push({
                  pathname: routePaths.bulkUploads.initiate,
                  search: '?type=' + BulkUploadTypes.TYPE_BULK_EMPLOYEE_UPDATE,
                });
              }}
            />
          )}
          {shouldShowBulkFnfActions && (
            <ActionListItem
              title="Bulk Full & Final Initiation"
              value="bulk-fnf-initiation"
              onClick={() => {
                history.push({
                  pathname: routePaths.bulkUploads.initiate,
                  search: '?type=' + BulkUploadTypes.TYPE_BULK_FNF_INITIATION,
                });
              }}
            />
          )}
          {shouldShowBulkFnfActions && (
            <ActionListItem
              title="Bulk Full & Final Settlement"
              value="bulk-fnf-settlement"
              onClick={() => {
                history.push({
                  pathname: routePaths.bulkUploads.initiate,
                  search: '?type=' + BulkUploadTypes.TYPE_BULK_FNF_SETTLEMENT,
                });
              }}
            />
          )}
        </ActionList>
      </DropdownOverlay>
    </Dropdown>
  );
};
